import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PanelInfo from '../../labels/PanelInfo';
import Menu from './Menu';
import Error from '../../dialogs/Error';

import * as home from '../../../actions/process.home.actions';
import * as actions from '../../../actions/process.inventory.actions';
import * as security from '../../../actions/session.actions'; 

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.props.setInventoryWindow(0);
    }

    componentDidMount() {
        this.props.loadBasicInfo();
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '62' || f === '64' || f === '80' || f === '84' || f === '110' || f === '111') &&
              info.security.licencias.some((f) => ( f.id === 150 || f.id === 151 || f.id === 152 || f.id === 154 || f.id === 156 || f.id === 157) && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <div
                        className={
                            'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                        }
                        onScroll={this.handleScroll}
                    >
                        <Menu />
                    </div>
                    <PanelInfo id={'manage_aux_message'} />
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        info: state.info,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions, home, security), dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Index));



// WEBPACK FOOTER //
// ./src/components/complex/manage/Index.js